export default "__VITE_ASSET__DLa7NktU__"